export default __webpack_public_path__ + "static/bg-analytic-light-4b46a592b6145a3856af4328c6ed6e86.png";